import * as i0 from "@angular/core";
export class BilSnackbarConfigService {
    constructor(configurationService) {
        this.configurationService = configurationService;
        this.config = {
            duration: 3000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
        };
    }
    getSnackbarConfig() {
        return this.config;
    }
}
BilSnackbarConfigService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BilSnackbarConfigService_Factory() { return new BilSnackbarConfigService(i0.ɵɵinject(BilSnackbarConfigService)); }, token: BilSnackbarConfigService, providedIn: "root" });
